import React, { useEffect, useState, useRef } from 'react';
import * as Yup from 'yup';
// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import BackgroundTheme from "../../../../Common/P2P/Header/BackgroundTheme";
import PersonalSecondForm from "./personalSecondForm";
import {
  checkDigit,
} from '../../../../utils/regExp';
import {
  getPersonalInfoReqSecondValue,
  getPersonalInfoReqValue,
  getPersonalInfoResetValue,
} from '../personalInfoAction';
import { checkPanCard } from '../../../../utils/utils';
import { getCustomerDetails } from '../../Auth/Login/actionLogin';
import { logFirebaseEvent } from '../../firebase';
import {
  P2P_BASIC_DETAILS_BTN,
  P2P_BASIC_DETAILS_VIEW,
} from '../../firebase/constant';
import { Typography } from '@material-ui/core';
import ProgressBar from '../../../../Common/ProgressBar';
const PersonalInfoSecond = () => {
  const dispatch = useDispatch();
  const formikRef: any = useRef();
  const history = useHistory();
  const [inputType, setInputType] = useState('text');
  const [addressAccess, setAddressAccess] = useState<boolean>(false);
  const [pinCodeAccess, setPinCodeAccess] = useState<boolean>(false);

  useEffect(() => {
    logFirebaseEvent(P2P_BASIC_DETAILS_VIEW);
    dispatch(getCustomerDetails(1));
    document.title = 'stashearn - personal-info';
  }, []);

  const { personalInfoData, genderData, error, personalInputValue } =
    useSelector((state: any) => state.personalInfo);

  const { customerData } = useSelector((state: any) => state.login);
  useEffect(() => {
    if (personalInfoData) {
      if (personalInfoData?.status) {
        history.push({ pathname: '/p2p/connectBank' });
        dispatch(getPersonalInfoResetValue());
      }
    }
    if (customerData && customerData.status) {
      if (
        customerData?.results?.address_line_1 !== '' &&
        customerData?.results?.address_line_1 !== null
      ) {
        setAddressAccess(true);
      }
      if (
        customerData?.results?.pincode !== '' &&
        customerData?.results?.pincode !== null
      ) {
        setPinCodeAccess(true);
      }
    }
  }, [personalInfoData, customerData]);

  const initialValues = {
   
    address:
      customerData?.results?.address_line_1 === null
        ? ''
        : customerData?.results?.address_line_1,
    pincode:
      customerData?.results?.pincode === null
        ? ''
        : customerData?.results?.pincode,
  };
  const validationSchema = () =>
    Yup.object().shape({
      address: Yup.string().required('*Required'),
      pincode: Yup.string()
        .matches(checkDigit, 'Digits only')
        .required('*Required')
        .min(6, 'Invalid Pin code'),
    });

  const onSubmitHandle = (value: any) => {
    logFirebaseEvent(P2P_BASIC_DETAILS_BTN);
    dispatch(getPersonalInfoReqSecondValue(value));
  };

  const onChangeField = () => {};

  const handleOnFocus = () => {
    setInputType('date');
  };

  const enterKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      if (formikRef?.current?.isValid) {
        onSubmitHandle(formikRef.current.values);
      }
    }
  };

  return (
    <>
      <BackgroundTheme>
        <Box className='personalInfo'>
          <ProgressBar 
          progress={70}
          />
          <Typography
            variant='h1'
            className='text-blue text-center fs-25 fw-800'
          >
            Let's get to know you <br /> better!
          </Typography>
          <PersonalSecondForm
            initialValues={initialValues}
            onSubmitHandle={onSubmitHandle}
            validationSchema={validationSchema}
            onChangeField={onChangeField}
            error={error}
            genderData={genderData}
            personalInputValue={personalInputValue}
            inputType={inputType}
            handleOnFocus={handleOnFocus}
            addressAccess={addressAccess}
            pinCodeAccess={pinCodeAccess}
            enterKeyPress={enterKeyPress}
            formikRef={formikRef}
          />
        </Box>
      </BackgroundTheme>
    </>
  );
};
export default PersonalInfoSecond;